import React, { useCallback, useEffect, useState } from "react";
import { useFormik } from "formik";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { IMAGE_URL, FORM_DATE_FORMAT } from "../../../utils/Constants";
import Select from "react-select";
import {
  CreateProgramme,
  UpdateProgramme,
  GetSchoolListCancelToken,
  GetNetsuiteProductListCancelToken,
  GetCommonContentCancelToken,
  getVersionDropdownList
} from "../../../services/ProgrammeServices";
import { setHours, setMinutes } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TrimText } from "../../common/TrimText";
import axios from "axios";
import HtmlInputEditor from "../../common/HtmlInputEditor";
import HtmlParser from "react-html-parser";
import ReactDOM from 'react-dom/server';
import PermissionsGate from '../../../utils/permissionGate';
import { usePermissionGuard, usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";

const ProgrammeForm = ({ setEnableAutodesk, enableAutodesk, setEnableProgramOverview, enableProgramOverview, programmeFunction, timeTableDoc, timeTableDocName, setTimeTableDoc, setTimeTableDocName, programmeData, refresh, setRefresh }) => {
  const { id, type } = useParams();
  const history = useHistory();
  const [disabled, setDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [openDate, setOpenDate] = useState(
    setHours(setMinutes(new Date(), 0), 9)
  );

  //DropDown Arrays Start
  const [programmeTypeArr, setProgrammeTypeArr] = useState([]);
  const [intakeArr, setIntakeArr] = useState([]);
  const [programmeLeadSupportArr, setProgrammeLeadSupportArr] = useState([]);
  const [studyTypeArr, setStudyTypeArr] = useState([]);
  const [crmProductArr, setCrmProductArr] = useState([]);
  const [netsuiteProductArr, setNetsuiteProductArr] = useState([]);
  const [campusArr, setCampusArr] = useState([]);
  const [documentTemplateArr, setDocumentTemplateArr] = useState([]);
  const [gradingStandardArr, setGradingStandardArr] = useState([])
  const [editorState, setEditorState] = useState("");
  const [pmcVersionList, setPmcVersionList] = useState([]);
  const [currentVersion, setCurrentVersion] = useState("")
  const [versionListLoading, setVersionListLoading] = useState(true)
  const [editDataCKeditor, setEditCKeditor] = useState({
    overview: '',
  }); 

  //DropDown Arrays End

  const [updateData, setUpdateData] = useState(true);
  const [schoolList, setSchoolList] = useState([]);

  const permissionAutodeskEdit = usePermissionGuard({
    scopes: ["caprogrammesdetailsautodeskedit"]
  });
  
  // Just giving more context as to why the user isn't able to change the setting:
  const autoDeskTitle = permissionAutodeskEdit === false ? 'You do not have permission to change this setting.' : '';

  //selected Dropdown Values
  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };

  useEffect(()=>{
    setEditorState(programmeData?.overview)
    setEditCKeditor({overview : programmeData?.overview})
    fetchActiveVersion(programmeData.netsuite_id, id, !programmeData.pmc_version_id ? true : false)
  },[programmeData])

  const fixNetsuiteArr = (arr) => {
    let tempArr = [];
    arr.map((item) => {
      let singleItem = {
        value: item.id,
        label: item.displayname,
        departmentId: item.department,
      };
      tempArr.push(singleItem);
    });
    setNetsuiteProductArr(tempArr);
  };

  useEffect(() => {
    const cancelTokenSources = [];
    const getSchoolsList = async ()=>{
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      try {
        let res = await GetSchoolListCancelToken(source.token)
        if (res.status == 200) {
          setSchoolList(res.data.data)
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    }
    getSchoolsList()

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, []);
  
  usePermissionGuardRedirect(['capview']);

  useEffect(() => {
    const cancelTokenSources = [];
    const getData = async () => {
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      try {
        let res = await GetNetsuiteProductListCancelToken("",source.token)
        if (res.status == 200) {
          fixNetsuiteArr(res.data.data.items)
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    }

    getData()

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, []);

  useEffect(() => {
    const cancelTokenSources = [];
    const getData = async () => {
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      try {
        let res = await GetCommonContentCancelToken(source.token)
        if (res.status == 200) {
          let tempIntakeArr = []
          res.data.intake_year.map(year => {
            res.data.intake_number.map(number => {
              tempIntakeArr.push({ value: `${year.value}/${number.label}`, label: `${year.value}-${number.label}` })
            })
          })
          setIntakeArr(tempIntakeArr)
          setCrmProductArr(res.data.crm_product && res.data.crm_product.results);
          setDocumentTemplateArr(res.data.document_template);
          setProgrammeLeadSupportArr(res.data.program_lead_support);
          setProgrammeTypeArr(res.data.programs);
          setStudyTypeArr(res.data.study_type);
          setCampusArr(res.data.program_campus);
          setDocumentTemplateArr(res.data.document_template);
          setGradingStandardArr(res?.data?.grading_standards || [])
          setIsLoading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    }

    getData()

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, []);

  const fetchActiveVersion = useCallback(async (netsuite_id,programme_id, updatePmcVersion = false) => {
    try {
      if (!netsuite_id || !programme_id) return 
      setVersionListLoading(true)
      const res = await getVersionDropdownList({netsuite_id , programme_id})
      setPmcVersionList(res?.data?.getVersionDropdown)

      const activeVersion = res?.data?.getVersionDropdown?.find((data) => data?.active_version == 1)
      setCurrentVersion(activeVersion?.value || "")

      if(updatePmcVersion){
        formik.setFieldValue("pmc_version_id", activeVersion?.value || "")
      }
      
    } catch (error) {
      console.log("error", error)
    } finally {
      setVersionListLoading(false)
    }
  }, []);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      Name: programmeData && programmeData.course ? programmeData.course : "",
      Code: programmeData && programmeData.code ? programmeData.code : "",
      is_show_overview: programmeData && programmeData.is_show_overview || 0,
      autodesk: programmeData && programmeData.autodesk || 0,
      intake: programmeData && programmeData.year && programmeData.number ? `${programmeData.year}/${programmeData.number}` : "",
      ProgrammeLead:
        programmeData && programmeData.programme_lead
          ? programmeData.programme_lead
          : "",
      ProgrammeSupport:
        programmeData && programmeData.programme_support
          ? programmeData.programme_support
          : "",
      StartDate:
        programmeData && programmeData.start
          ? new Date(programmeData.start)
          : "",
      EndDate:
        programmeData && programmeData.end ? new Date(programmeData.end) : "",
      StudyType: programmeData && programmeData.type ? programmeData.type : "",
      ProgrammeType:
        programmeData && programmeData.program_type
          ? programmeData.program_type
          : "",
        grading_standard:
         programmeData && programmeData.grading_standard
          ? programmeData.grading_standard
          : 1, 
      CRMProductId:
        programmeData && programmeData.product_id
          ? programmeData.product_id
          : "",
      NetsuiteProductId:
        programmeData && programmeData.netsuite_id
          ? programmeData.netsuite_id
          : "",
      netsuite_department_id:
        programmeData && programmeData.netsuite_department_id
          ? programmeData.netsuite_department_id
          : "",
      Campus: programmeData && programmeData.campus ? programmeData.campus : "",
      School:
        programmeData && programmeData.school_type
          ? programmeData.school_type
          : "",
      DocumentTemplate:
        programmeData && programmeData.pdf_template_id
        ? programmeData.pdf_template_id
        : "",
        TimeTable:
        programmeData && programmeData.timeTable !== null &&programmeData.timeTable !== "null" && programmeData.timeTable ? programmeData.timeTable : "",
        editorState: programmeData && programmeData.overview ? programmeData.overview : "<p></p>",
        override_pmc_version: programmeData?.override_pmc_version || 0,
        pmc_version_id: programmeData?.pmc_version_id || 0
      },
      validationSchema: Yup.object({
        Name: Yup.string()
        .trim("Name cannot include leading and trailing spaces")
        .required("Name is required"),
      Code: Yup.string()
        .max(20, "Max 20 Character Accepted")
        .trim("Code cannot include leading and trailing spaces"),
      intake: Yup.string().required("Intake is required"),
      ProgrammeLead: Yup.string().required("Programme Lead is required"),
      StartDate: Yup.string().required("Start Date is required"),
      EndDate: Yup.string().required("End Date is required"),
      StudyType: Yup.string().required("Learning Method is required"),
      ProgrammeType: Yup.string().required("Programme Type is required"),
      // grading_standard validation field is now optional 
      Campus: Yup.string().required("Campus is required"),
      School: Yup.string().required("School is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      let tempFullStartDate = new Date(values?.StartDate);
      let tempStart =
        tempFullStartDate.getDate() +
        "-" +
        (tempFullStartDate.getMonth() + 1) +
        "-" +
        tempFullStartDate.getFullYear();
      let tempFullEndDate = new Date(values?.EndDate);
      let tempEnd =
        tempFullEndDate.getDate() +
        "-" +
        (tempFullEndDate.getMonth() + 1) +
        "-" +
        tempFullEndDate.getFullYear();
      if (tempFullStartDate > tempFullEndDate) {
        formik.setFieldError(
          "StartDate",
          "Start date should be less than end date"
        );
      }else{

      setDisabled(true);
      let formData = new FormData();
      type == "open" && formData.append("id", id);
      formData.append("course", values?.Name);
      formData.append("number", values?.intake.split("/")[1]);
      formData.append("start", tempStart);
      formData.append("end", tempEnd);
      formData.append("type", values?.StudyType);
      formData.append("campus", values?.Campus);
      formData.append("code", values?.Code);
      formData.append("year", values?.intake.split("/")[0]);
      formData.append("programme_lead", values?.ProgrammeLead);
      formData.append("programme_support", values?.ProgrammeSupport);
      formData.append("pdf_template_id", values?.DocumentTemplate);
      formData.append("product_id", values?.CRMProductId);
      formData.append("product_name", values?.Name);
      formData.append("school_type", values?.School);
      formData.append("timeTable", timeTableDoc);
      formData.append("program_type", values?.ProgrammeType);
      formData.append("netsuite_id", values?.NetsuiteProductId);
      formData.append("netsuite_department_id", values?.netsuite_department_id);
      formData.append("grading_standard", values?.grading_standard || 1); 
      formData.append("is_show_overview", values?.is_show_overview);
      formData.append("autodesk", values?.autodesk);
      formData.append("overview",editorState && editorState ? editorState : "<p></p>")
      formData.append('override_pmc_version',values?.override_pmc_version)
      formData.append('pmc_version_id',values?.pmc_version_id || 0)
      if (type == "open") {
        UpdateProgramme(formData)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Updated successfully",
            });
            setDisabled(false);
            setUpdateData(!updateData);
            setRefresh(!refresh)
          })
          .catch((err) => {
            setDisabled(false);
            Swal.fire({
              icon: "error",
              title: "Failed",
              text: err.response.data[0].message,
            });
            console.log("error :", err.response);
          });
      } else {
        if (type == "duplicate") {
          formData.append("duplicateId", id)
        }
        CreateProgramme(formData)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Added successfully",
            });
            setDisabled(false);
            history.push("/courseAdministration/Programmes/programme/show");
          })
          .catch((err) => {
            setDisabled(false);
            Swal.fire({
              icon: "error",
              title: "Failed",
              text: err.response.data[0].message,
            });
            console.log("error :", err);
          });
      }
    }
    },
  });

  const modifiyOptionsForSelect = (arr) => {
    let modifiedArr = [];
    arr && arr.map((elem) => {
      modifiedArr.push({
        value: elem[0],
        label: elem[1] + " (" + elem[4] + ") " + elem[2],
        id: elem[0],
      });
    });

    return modifiedArr;
  };

  const handleTimeTable = () => {
    formik.setFieldValue("TimeTable", "");
    setTimeTableDoc("");
    setTimeTableDocName("");
  }


  /**
   * Returns an icon representing the PMC version status.
   *
   * Logic:
   * - No icon if values missing or loading.
   * - Warning Icon: override enabled + version mismatch.
   * - Checked Icon: version matches active version.
  */
  const getPmcVersionIcon = () => {
    const { pmc_version_id, override_pmc_version } = formik.values;
    // If any required values are missing, show nothing
    if (!(currentVersion && !versionListLoading)) {
      return null;
    }

    // Override and different version 
    if (override_pmc_version && currentVersion !== pmc_version_id ) {
      return (
        <i
          title="PMC Version Override"
          className="fas fa-exclamation-circle bg-orange-icon ml-1"
        ></i>
      );
    }

    // version match
    return (
      <i
        title="Active PMC Version"
        className="fas fa-circle-check bg-green-icon ml-1"
      ></i>
    );
  };


  /**
   * Returns an icon representing the PMC version status.
   *
   * Logic:
   * - No icon if values missing or loading.
   * - Warning: override enabled + version mismatch.
   * - Green check: version matches active version.
  */
  const renderActivePmcWarning = () => {
    const { pmc_version_id, override_pmc_version } = formik.values;
    const activeVersion = pmcVersionList?.find((v) => v.active_version == 1);

    // Guard: if values are missing or version list is still loading, render nothing
    if (!(currentVersion && !versionListLoading)) return null;

    // Show warning only when override is ON and the versions mismatch
    if (currentVersion !== pmc_version_id && override_pmc_version) {
      return (
        <div className="d-flex align-items-center active-pmc-div mt-2 mb-4">
          <i className="fas fa-exclamation-circle bg-orange-icon mr-1"></i>
          Active PMC Version:
          <span className="ml-1" title={activeVersion?.label || ""}>
            {activeVersion?.label || ""}
          </span>
        </div>
      );
    }

    return null;
  };



  return (
    <div className="card card-body-inr">
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-6 col-lg-3">
            <label htmlFor="Name"> Name *</label>
            <div className="form-icon-group mb-4" title="Name">
              <input
                type="text"
                className={
                  "form-control" +
                  (formik.errors.Name && formik.touched.Name
                    ? " is-invalid"
                    : "")
                }
                name="Name"
                id="Name"
                placeholder="Name"
                title="Name"
                value={formik.values.Name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <label htmlFor="Intake">Intake *</label>
            <div className="">
              <div className="form-icon-group mb-4 ">
                <Select
                  className={
                    "form-control custom-select-box " +
                    (formik.errors.intake && formik.touched.intake
                      ? " is-invalid"
                      : "")
                  }
                  name="Intake"
                  value={intakeArr.filter((val) => {
                    return val.value == formik.values.intake
                  })}
                  onChange={(value) => {
                    if (value) {
                      formik.setFieldValue("intake", value.value);
                    } else {
                      formik.setFieldValue("intake", "");
                    }
                  }}
                  isClearable
                  onBlur={formik.handleBlur}
                  options={intakeArr}
                  maxMenuHeight={175}
                  placeholder={
                    formik.values.intake
                      ? formik.values.intake
                      : "Select"
                  }
                />
              </div>
            </div>
          </div>
          {/* <div className="col-md-6 col-lg-3">
            <label htmlFor="DocumentTemplate">Document Template </label>
            <div className="">
              <div className="form-icon-group mb-4 ">
                <Select
                  className={
                    "form-control custom-select-box " +
                    (formik.errors.DocumentTemplate &&
                      formik.touched.DocumentTemplate
                      ? " is-invalid"
                      : "")
                  }
                  name="DocumentTemplate"
                  value={documentTemplateArr.filter(function (option) {
                    return option.value == formik.values.DocumentTemplate;
                  })}
                  onChange={(value) => {
                    if (value) {
                      formik.setFieldValue("DocumentTemplate", value.value);
                    } else {
                      formik.setFieldValue("DocumentTemplate", "");
                    }
                  }}
                  isClearable
                  onBlur={formik.handleBlur}
                  options={documentTemplateArr}
                  maxMenuHeight={175}
                  placeholder={
                    formik.values.DocumentTemplate
                      ? formik.values.DocumentTemplate
                      : "Select"
                  }
                />
                {formik.errors.DocumentTemplate &&
                  formik.touched.DocumentTemplate ? (
                  <span className="exclamation">
                    <i className="fal fa-exclamation-circle"></i>
                  </span>
                ) : null}
              </div>
            </div>
          </div> */}
          <div className="col-md-6 col-lg-3">
            <label htmlFor="Code">Code </label>
            <div className="form-icon-group mb-4" title="Title">
              <input
                type="text"
                className={
                  "form-control" +
                  (formik.errors.Code && formik.touched.Code
                    ? " is-invalid"
                    : "")
                }
                name="Code"
                id="Code"
                placeholder="Code"
                title="Code"
                value={formik.values.Code}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <label htmlFor="ProgrammeLead">Programme Coordinator *</label>
            <div className="">
              <div className="form-icon-group mb-4 ">
                <Select
                  className={
                    "form-control custom-select-box " +
                    (formik.errors.ProgrammeLead && formik.touched.ProgrammeLead
                      ? " is-invalid"
                      : "")
                  }
                  name="ProgrammeLead"
                  value={programmeLeadSupportArr.filter(function (option) {
                    return option.value == formik.values.ProgrammeLead;
                  })}
                  onChange={(value) => {
                    if (value) {
                      formik.setFieldValue("ProgrammeLead", value.value);
                    } else {
                      formik.setFieldValue("ProgrammeLead", "");
                    }
                  }}
                  isClearable
                  onBlur={formik.handleBlur}
                  options={programmeLeadSupportArr}
                  maxMenuHeight={175}
                  placeholder={
                    formik.values.ProgrammeLead
                      ? formik.values.ProgrammeLead
                      : "Select"
                  }
                />
                {formik.errors.ProgrammeLead && formik.touched.ProgrammeLead ? (
                  <span className="exclamation">
                    <i className="fal fa-exclamation-circle"></i>
                  </span>
                ) : null}
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-3">
            <label htmlFor="ProgrammeSupport">Programme Support</label>
            <div className="">
              <div className="form-icon-group mb-4 ">
                <Select
                  className={
                    "form-control custom-select-box " +
                    (formik.errors.ProgrammeSupport &&
                      formik.touched.ProgrammeSupport
                      ? " is-invalid"
                      : "")
                  }
                  name="ProgrammeSupport"
                  value={programmeLeadSupportArr.filter(function (option) {
                    return option.value == formik.values.ProgrammeSupport;
                  })}
                  onChange={(value) => {
                    if (value) {
                      formik.setFieldValue("ProgrammeSupport", value.value);
                    } else {
                      formik.setFieldValue("ProgrammeSupport", "");
                    }
                  }}
                  isClearable
                  onBlur={formik.handleBlur}
                  options={programmeLeadSupportArr}
                  maxMenuHeight={175}
                  placeholder={
                    formik.values.ProgrammeSupport
                      ? formik.values.ProgrammeSupport
                      : "Select"
                  }
                />
                {formik.errors.ProgrammeSupport &&
                  formik.touched.ProgrammeSupport ? (
                  <span className="exclamation">
                    <i className="fal fa-exclamation-circle"></i>
                  </span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <label>Start Date *</label>
            <div className="form-group-blk mb-3">
              <DatePicker
                selected={formik.values.StartDate}
                onChange={(date) => {
                  formik.setFieldValue("StartDate", date);
                  setOpenDate(date);
                }}
                filterTime={filterPassedTime}
                dateFormat={FORM_DATE_FORMAT}
                className={
                  "form-control cursor-pointer" +
                  (formik.errors.StartDate && formik.touched.StartDate
                    ? " is-invalid"
                    : "")
                }
                title="Start Date"
                onBlur={formik.handleBlur}
                placeholderText="Select Date"
                minDate={new Date()}
                onChangeRaw={(e) => e.preventDefault()}
              />
            </div>
            {formik.errors.StartDate && formik.touched.StartDate ? (
              <span className="exclamation">
                <i className="fal fa-exclamation-circle"></i>
              </span>
            ) : null}
          </div>
          <div className="col-md-6 col-lg-3">
            <label>End Date *</label>
            <div className="form-group-blk mb-3">
              <DatePicker
                selected={formik.values.EndDate}
                onChange={(date) => {
                  formik.setFieldValue("EndDate", date);
                }}
                filterTime={filterPassedTime}
                dateFormat={FORM_DATE_FORMAT}
                className={
                  "form-control cursor-pointer" +
                  (formik.errors.EndDate && formik.touched.EndDate
                    ? " is-invalid"
                    : "")
                }
                title="End Date"
                onBlur={formik.handleBlur}
                placeholderText="Select Date"
                disabled={!formik.values.StartDate}
                minDate={formik.values.StartDate}
                onChangeRaw={(e) => e.preventDefault()}
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <label htmlFor="StudyType">Learning Method *</label>
            <div className="">
              <div className="form-icon-group mb-4 ">
                <Select
                  className={
                    "form-control custom-select-box " +
                    (formik.errors.StudyType && formik.touched.StudyType
                      ? " is-invalid"
                      : "")
                  }
                  name="StudyType"
                  value={studyTypeArr.filter(function (option) {
                    return option.value == formik.values.StudyType;
                  })}
                  onChange={(value) => {
                    if (value) {
                      formik.setFieldValue("StudyType", value.value);
                    } else {
                      formik.setFieldValue("StudyType", "");
                    }
                  }}
                  onBlur={formik.handleBlur}
                  options={studyTypeArr}
                  maxMenuHeight={175}
                  placeholder={
                    formik.values.StudyType ? formik.values.StudyType : "Select"
                  }
                  isClearable
                />
                {formik.errors.StudyType && formik.touched.StudyType ? (
                  <span className="exclamation">
                    <i className="fal fa-exclamation-circle"></i>
                  </span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <label htmlFor="ProgrammeType">Programme Type *</label>
            <div className="">
              <div className="form-icon-group mb-4 ">
                <Select
                  className={
                    "form-control custom-select-box " +
                    (formik.errors.ProgrammeType && formik.touched.ProgrammeType
                      ? " is-invalid"
                      : "")
                  }
                  name="ProgrammeType"
                  value={programmeTypeArr.filter(function (option) {
                    return option.value == formik.values.ProgrammeType;
                  })}
                  onChange={(value) => {
                    if (value) {
                      formik.setFieldValue("ProgrammeType", value.value);
                    } else {
                      formik.setFieldValue("ProgrammeType", "");
                    }
                  }}
                  isClearable
                  onBlur={formik.handleBlur}
                  options={programmeTypeArr}
                  maxMenuHeight={175}
                  placeholder={
                    formik.values.ProgrammeType
                      ? formik.values.ProgrammeType
                      : "Select"
                  }
                />
                {formik.errors.ProgrammeType && formik.touched.ProgrammeType ? (
                  <span className="exclamation">
                    <i className="fal fa-exclamation-circle"></i>
                  </span>
                ) : null}
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-3">
            <label htmlFor="gradingStandard" title="Grading Standard">Grading Standard
            <i className="fal fa-info-circle ml-1" title={"The grading standard determines how grades are structured for the programme"}></i>
            </label>
            <div className="">
              <div className="form-icon-group mb-4 ">
              <Select
              className={
                "form-control custom-select-box " +
                (formik.errors.grading_standard && formik.touched.grading_standard
                  ? " is-invalid"
                  : "")
                }
                name="gradingStandard"
                value={gradingStandardArr?.filter(function (option) {
                  return option.value == formik.values?.grading_standard;
                })}
                onChange={(value) => {
                  if (value && !programmeData?.assigned_courses) {
                    formik.setFieldValue("grading_standard", value?.value);
                  } else if (programmeData?.assigned_courses) {
                    Swal.fire({
                      icon: "warning",
                      title: "Warning",
                      text: `Changing the grade type on this programme is not recommended due to the programme being linked to courses that are assigned to other ${formik.values?.grading_standard == 2 ? "Grade Mix" : "Default" } type programmes.`,
                      confirmButtonText: 'Confirm',
                      cancelButtonText: 'Cancel',
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      showCancelButton: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // User clicked confirm
                        formik.setFieldValue("grading_standard", value?.value);
                      }
                    });
                  } else {
                    formik.setFieldValue("grading_standard", "");
                  }
                }}
                isClearable
                onBlur={formik.handleBlur}
                options={gradingStandardArr}
                maxMenuHeight={175}
                isDisabled={true}
                placeholder={
                  formik.values.grading_standard
                  ? formik.values.grading_standard
                  : "Select"
                }
                />
                {formik.errors.grading_standard && formik.touched.grading_standard ? (
                  <span className="exclamation">
                  <i className="fal fa-exclamation-circle"></i>
                  </span>
                  ) : null}
                  </div>
                </div>
          </div>

          {/* <div className="col-md-6 col-lg-3">
            <label htmlFor="CRMProductId">CRM Product</label>
            <div className="">
              <div className="form-icon-group mb-4 ">
                <Select
                  className={
                    "form-control custom-select-box " +
                    (formik.errors.CRMProductId && formik.touched.CRMProductId
                      ? " is-invalid"
                      : "")
                  }
                  name="CRMProductId"
                  value={modifiyOptionsForSelect(crmProductArr).filter(
                    function (option) {
                      return option.id == formik.values.CRMProductId;
                    }
                  )}
                  onChange={(value) => {
                    if (value) {
                      formik.setFieldValue("CRMProductId", value.value);
                    } else {
                      formik.setFieldValue("CRMProductId", "");
                    }
                  }}
                  isClearable
                  onBlur={formik.handleBlur}
                  options={
                    crmProductArr ? modifiyOptionsForSelect(crmProductArr) : []
                  }
                  maxMenuHeight={175}
                  placeholder={
                    formik.values.CRMProductId
                      ? formik.values.CRMProductId
                      : "Select"
                  }
                />
                {formik.errors.CRMProductId && formik.touched.CRMProductId ? (
                  <span className="exclamation">
                    <i className="fal fa-exclamation-circle"></i>
                  </span>
                ) : null}
              </div>
            </div>
          </div> */}
          <div className="col-md-6 col-lg-3">
            <label htmlFor="NetsuiteProductId">Netsuite Product</label>
            <div className="">
              <div className="form-icon-group mb-4 ">
                <Select
                  className={
                    "form-control custom-select-box " +
                    (formik.errors.NetsuiteProductId &&
                      formik.touched.NetsuiteProductId
                      ? " is-invalid"
                      : "")
                  }
                  name="NetsuiteProductId"
                  value={netsuiteProductArr.filter(function (option) {
                    return option.value == formik.values.NetsuiteProductId;
                  })}
                  onChange={(value) => {
                    formik.setFieldValue("pmc_version_id","")
                    formik.setFieldValue("override_pmc_version",0)
                    if (value) {
                      formik.setFieldValue("NetsuiteProductId", value.value);
                      formik.setFieldValue(
                        "netsuite_department_id",
                        value.departmentId
                      );
                    } else {
                      formik.setFieldValue("NetsuiteProductId", "");
                      formik.setFieldValue(
                        "netsuite_department_id",
                        ""
                      );
                    }
                    fetchActiveVersion(value?.value,id, true )

                  }}
                  isClearable
                  onBlur={formik.handleBlur}
                  options={netsuiteProductArr}
                  maxMenuHeight={175}
                  placeholder={
                    formik.values.NetsuiteProductId
                      ? formik.values.NetsuiteProductId
                      : "Select"
                  }
                />
                {formik.errors.NetsuiteProductId &&
                  formik.touched.NetsuiteProductId ? (
                  <span className="exclamation">
                    <i className="fal fa-exclamation-circle"></i>
                  </span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <label htmlFor="Campus">Campus *</label>
            <div className="">
              <div className="form-icon-group mb-4 ">
                <Select
                  className={
                    "form-control custom-select-box " +
                    (formik.errors.Campus && formik.touched.Campus
                      ? " is-invalid"
                      : "")
                  }
                  name="Campus"
                  value={campusArr.filter(function (option) {
                    return option.value == formik.values.Campus;
                  })}
                  onChange={(value) => {
                    if (value) {
                      formik.setFieldValue("Campus", value.value);
                    } else {
                      formik.setFieldValue("Campus", "");
                    }
                  }}
                  isClearable
                  onBlur={formik.handleBlur}
                  options={campusArr}
                  maxMenuHeight={175}
                  placeholder={
                    formik.values.Campus ? formik.values.Campus : "Select"
                  }
                />
                {formik.errors.Campus && formik.touched.Campus ? (
                  <span className="exclamation">
                    <i className="fal fa-exclamation-circle"></i>
                  </span>
                ) : null}
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3">
            <label htmlFor="School">School *</label>
            <div className="">
              <div className="form-icon-group mb-4 ">
                <Select
                  className={"form-control custom-select-box " + (formik.errors.School && formik.touched.School ? " is-invalid" : "")}
                  name="School"
                  value={schoolList.filter((item) => {
                    return item.value == formik.values.School;
                  })}
                  onChange={(value) => {
                    if (value) {
                      formik.setFieldValue("School", value.value);
                    } else {
                      formik.setFieldValue("School", "");
                    }
                  }}
                  isClearable
                  onBlur={formik.handleBlur}
                  options={schoolList}
                  maxMenuHeight={175}
                  placeholder={formik.values.School ? formik.values.School : "Select"}
                />
                {formik.errors.School && formik.touched.School ? (
                  <span className="exclamation">
                    <i className="fal fa-exclamation-circle"></i>
                  </span>
                ) : null}
              </div>
            </div>
          </div>          
          <div className="col-md-6 col-lg-3 mb-4">
            <label htmlFor="IndexLogo" style={{ marginBottom: 13 }}>
              Time Table
            </label>
            <div className="form-group atttach-file">
              <label
                className={
                  formik.errors.TimeTable &&
                  formik.touched.TimeTable &&
                  " file-req is-invalid"
                }
              >
                <i className="fal fa-paperclip"></i>
                <span>Add Attachment</span>
                <input
                  type="file"
                  id="input"
                  className="form-control  form-control-aatch-file"
                  name="file"
                  title="Time Table"
                  onChange={(e) => {
                    if (e.target.files.length) {
                      formik.setFieldValue("TimeTable", e.target.files[0]);
                      setTimeTableDoc(e.target.files[0]);
                      setTimeTableDocName(URL.createObjectURL(e.target.files[0]));
                    }
                  }}
                />
              </label>
            </div>
            {timeTableDocName && timeTableDocName !== "undefined" && (
              <>
                <div className="frm-group">
                  <ul className="list-unstyled attached-file-ul m-0">
                    <li>

                      <a
                        title={timeTableDocName}
                        href={
                          timeTableDocName.includes("blob")
                            ? timeTableDocName
                            : `${IMAGE_URL}/${encodeURI(timeTableDocName.replaceAll(
                              "/public/",
                              ""
                            ).replaceAll("home/myaie/public_html/", ""))}`
                        }
                        target="_blank"
                      >
                        <i className="fal fa-file"></i>
                        &nbsp;{
                          timeTableDoc?.name
                            ? TrimText(timeTableDoc?.name, 40)
                            : TrimText(formik.values.TimeTable.split(
                              "/"
                            ).reverse()[0], 40)

                        }
                      </a>
                      <button
                        className="btn btn-danger rounded-circle btn-dropdown-item"
                        title="Delete"
                        onClick={() => handleTimeTable()}
                      >
                        <i className="fal fa-trash-alt"></i>
                      </button>


                    </li>
                  </ul>
                </div>
              </>
            )}

            {formik.errors.TimeTable && formik.touched.TimeTable ? (
              <span className="exclamation">
                <i className="fal fa-exclamation-circle"></i>
              </span>
            ) : null}
          </div>
          {formik.values?.NetsuiteProductId && Boolean(programmeData?.qualificationsLinkedPmc) && (
          <>
            <div className="col-md-6 col-lg-3">
              <label htmlFor="pmc_version_id">
                PMC Version
                <i className="fal fa-info-circle ml-1" title="PMC Version"></i>

                {getPmcVersionIcon()}
              </label>

        
              <div className={formik.values.override_pmc_version ? "mb-2" : "mb-4"}>
                <div className="form-icon-group">
                  <Select
                    className={
                      "form-control custom-select-box " +
                      (formik.errors.pmc_version_id && formik.touched.pmc_version_id
                        ? " is-invalid"
                        : "")
                    }
                    name="pmc_version_id"
                    value={pmcVersionList?.find((option) => option.value == (formik.values.override_pmc_version ? formik.values.pmc_version_id : currentVersion)) || null}
                    isDisabled={!formik.values?.override_pmc_version}
                    onChange={(value) => {
                      if (value) {  
                        formik.setFieldValue("pmc_version_id", value.value);
                      } else {
                        formik.setFieldValue("pmc_version_id", "");
                      }
                    }}
                    onBlur={formik.handleBlur}
                    options={pmcVersionList}
                    maxMenuHeight={175}
                    placeholder="Select"
                  />
                </div>

                {renderActivePmcWarning()}

              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="d-flex align-items mt-3" title="Override PMC Version">
                <label className="mb-0">
                  Override PMC Version <i className="fal fa-info-circle ml-1"></i>
                </label>
                <div className="toggle-switch ml-2">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={formik.values?.override_pmc_version}
                      onChange={(e) => {
                        const newValue = e.target.checked ? 1 : 0;
                        formik.setFieldValue("override_pmc_version", newValue);
                        if(!e.target.checked){
                          formik.setFieldValue('pmc_version_id',currentVersion)
                        }
                      }}
                    />
                    <span className="slider slider-round"></span>
                  </label>
                </div>
              </div>
            </div>
            </>
          )}                     
          <div className="col-md-6 col-lg-3 mb-4">
            <div className="d-flex align-items mt-3" title="Enable Programme Overview">
              <label className="mb-0">
                Enable Programme Overview
              </label>
              <div className="toggle-switch ml-2">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={enableProgramOverview}
                    onChange={(e) => {
                      const newValue = e.target.checked ? 1 : 0;
                      setEnableProgramOverview(e.target.checked);
                      formik.setFieldValue("is_show_overview", newValue);
                    }}
                  />
                  <span className="slider slider-round"></span>
                </label>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 mb-4">
            <div className="d-flex align-items mt-3" title="Enable Autodesk License">
              <label className="mb-0">
                Enable Autodesk License
              </label>
              <div className="toggle-switch ml-2">
                <label className="switch">
                  <PermissionsGate scopes={["caprogrammesdetailsautodeskedit"]} errorProps={{ disabled: true }}>
                    <input
                      type="checkbox"
                      checked={enableAutodesk}
                      onChange={(e) => {
                        const newValue = e.target.checked ? 1 : 0;
                        setEnableAutodesk(e.target.checked);
                        formik.setFieldValue("autodesk", newValue);
                      }}
                    />
                  </PermissionsGate>
                  <span className="slider slider-round" title={autoDeskTitle}></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        {enableProgramOverview ? <div className="col-md-12" style={{paddingRight:"0", paddingLeft:"0"}}>
          <div className="form-group-blk mb-3">
            <label>Overview</label>
            <HtmlInputEditor
              editorState={editorState}
              setEditorState={(newState) => {
                setEditorState(newState);
                formik.setFieldValue("editorState", newState); 
              }}
              initialValue={programmeData?.overview}
              hideSign={true}
              isCKEditor={true}
            />
          </div>
        </div> : null}

        <div className="form-group form-group-save-cancel">
          {type == "add" || type == "duplicate" ? <button className="btn btn-save btn-success" type="submit" title="Save" disabled={disabled}>
            {disabled ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-save"></i>}
            Save
          </button> :
            <button className="btn btn-save btn-success" type="submit" title="Save"  disabled={
              isLoading ||
              (!formik.dirty &&
                ReactDOM.renderToString(
                  HtmlParser(editDataCKeditor.overview)
                ) === ReactDOM.renderToString(HtmlParser(editorState))
                ? true
                : false)
            }>
              {disabled ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-save"></i>}
              Save
            </button>
          }
          <button
            className="btn btn-close btn-danger"
            type="button"
            title="Cancel"
            onClick={()=>{
              if(type == "open"){
                setRefresh(!refresh)
                formik.resetForm()
              }else{
                history.goBack()
              }
            }}
          >
            <i className="fal fa-times"></i>
            Cancel
          </button>

          {Object.keys(formik.values).map(key => {
            if (formik.touched[key] && formik.errors[key]) {
              return (
                <div className="invalid-feedback d-block" key={key}>
                  {formik.errors[key]}
                </div>
              )
            }
          })}
        </div>
      </form>
    </div>
  );
};

export default ProgrammeForm;
